import { useEffect, useState } from "react";
import { ToastTypes } from "../../contexts/toastr.context";
import { useToast } from "../../hooks/use-toast.hook";
import { Community } from "../../types/community/community.type";
import { Group } from "../../types/group/group.type";
import { User } from "../../types/user/minimal-user.type";
import { Button } from "../../_components";
import { Checkbox } from "../../_components/form-controls/checkbox.component";
import IconButton2 from "../../_components/icon-button-2-component";
import { Modal } from "../../_components/modal.component";
import { GroupService } from "../../_service";
import { RoleService } from "../../_service/role.service";
import Validator from "../../_utils/validator";

interface Props {
  user: User;
  member: any;
  community: Community;
  groups: Array<Group>;
  isActive: boolean;
  setIsActive: any;
}

/**
 * @param {object} user - Auth user object
 * @param {object} member - The member whose role is to be updated
 * @param {object} community - The community object
 * @param {object} groups - The groups to which the member is to be added
 * @param {boolean} isActive - Whether the modal is visible or not
 * @param {function} setIsActive - Function to set the modal visibility
 */
export default function AddToGroupModal({
  user,
  member,
  community,
  groups,
  isActive,
  setIsActive,
}: Props) {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedGroups, setSelectedGroups] = useState<Array<any>>([]);

  const { addToast } = useToast();

  const role = "user";

  //   TODO: Handle the error
  async function handleSubmit(e: any) {
    if (!Validator.hasValue(selectedGroups)) {
      return;
    }
    e.preventDefault();
    setIsLoading(true);
    let groupIds = selectedGroups.map((item: any) => item.id);
    setIsLoading(true);
    for (let i = 0; i < groupIds.length; i++) {
      try {
        await GroupService.updateUserRole(user, groupIds[i], member.id, role);
      } catch (error) {
        console.log(error);
      }
    }
    setIsLoading(false);
    addToast(
      `${member.name} is added to ${selectedGroups
        .map((item: any) => item.name)
        .join(", ")}`,
      "",
      ToastTypes.success
    );
  }

  // Fetch the role of the member in the community for all groups
  useEffect(() => {
    if (!isActive) {
      return;
    }

    RoleService.getRole(community.id!, member.id)
      .then(({ user, selectedRole, groupRoles }) => {
        // Find all key values pairs in groupRoles where value is is not null
        let selectedGroups = Object.keys(groupRoles).filter(
          (key) => groupRoles[key] !== null
        );
        // Map the selectedGroups to an array of objects
        let selectedGroupsArray = selectedGroups.map((key) => ({
          id: key,
          name: groups.find((group) => group.id === key)?.name,
        }));
        setSelectedGroups(selectedGroupsArray);
      })
      .catch((err) => {
        console.log("RoleService.getRole failed", { err });
        // addToast("Failed to get role", "", ToastTypes.danger);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [member, community?.id, groups, isActive]);

  if (!isActive) {
    return null;
  }

  return (
    <>
      <Modal
        active={isActive}
        setIsActive={setIsActive}
        padding={false}
        width={"600px"}>
        <div>
          <div className="pl-4 pr-2 py-2 theme-bg-surface flex items-center justify-between">
            <span className="font-bold theme-text-heading-2">Add to group</span>
            <IconButton2
              hoverable={true}
              icon="cross"
              size="xs"
              iconClass="theme-text-subtitle-2 text-xs"
              onClick={() => {
                setIsActive(false);
              }}
            />
          </div>
          {/* body */}
          <div className="p-5 theme-text-heading-1 theme-bg-default">
            <div className="flex flex-col space-y-2 px-4 py-2">
              {/* <div className="font-semibold"></div> */}
              {/* Groups List */}
              <div className="rounded theme-bg-surface select-none">
                {groups && groups.length > 0
                  ? groups.map((group: any, index: number) => {
                      let isSelected = selectedGroups.find(
                        (g: any) => g.id === group.id
                      );
                      return (
                        <div
                          key={index}
                          className="py-1 px-4 theme-bg-surface rounded">
                          <div key={index} className=" mt-1">
                            <Checkbox
                              className={"my-2 mr-5"}
                              selected={isSelected}
                              onClick={() => {
                                if (isSelected) {
                                  let tempList = selectedGroups.filter(
                                    (g: any) => g.id !== group.id
                                  ) as any;
                                  // setSelectedGroups(tempList);
                                  setSelectedGroups(tempList);
                                } else {
                                  setSelectedGroups([
                                    ...selectedGroups,
                                    {
                                      name: group.name,
                                      id: group.id,
                                      selected: true,
                                    },
                                  ]);
                                }
                              }}>
                              <div className={"flex items-center"}>
                                <span
                                  className={`${
                                    // disableState ? "theme-text-subtitle-2" : ""
                                    ""
                                  } pl-3`}>
                                  {group.name}
                                </span>
                              </div>
                            </Checkbox>
                          </div>
                        </div>
                      );
                    })
                  : null}
              </div>
            </div>
          </div>
          {/* Hide share post for temp fix */}
          <div className="flex justify-between p-4">
            <button
              // label="Cancel"
              onClick={() => {
                setIsActive(false);
              }}>
              Cancel
            </button>
            <Button
              label="Save"
              disabled={selectedGroups.length === 0}
              onClick={handleSubmit}
              isLoading={isLoading}
            />
          </div>
        </div>
      </Modal>
    </>
  );
}
